export const API_CONFIG = {
    BASE_URL: 'https://api.mewtrader.com',
    HEADERS: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
};
